var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    class: ['product-rating', ("product-rating_h-" + (_vm.size))]
  }, [_vm._l(5, function (el) {
    return _c('div', {
      key: el,
      staticClass: "product-rating__el-wrap"
    }, [_c('div', {
      staticClass: "product-rating__el",
      class: {
        'product-rating__el_filled': el <= _vm.count
      }
    })]);
  }), _vm._v(" "), _vm.showStatus ? _c('div', {
    class: ['product-rating__text', {
      'product-rating__text_orange': _vm.count === 5
    }]
  }, [_vm._v("\n    " + _vm._s(_vm.status) + "\n  ")]) : _vm._e()], 2);
}
var staticRenderFns = []

export { render, staticRenderFns }